export const modalConfig = {
  animation: {
    enterExitDurationMs: 300,
    activateDelayMs: 16,
  },
  gesture: {
    closeDistancePx: 96,
    closeVelocityPxPerMs: 0.6,
    maxDragOffsetPx: 280,
  },
  layout: {
    defaultMaxHeight: '90vh',
    /** Extra gap (px) between the modal top edge and the safe-area boundary. */
    safeTopOffsetPx: 12,
    baseZIndex: 10000,
    nestedZIndexOffset: 10,
    swipeHandleTopPaddingPx: 24,
    swipeHandleBottomPaddingPx: 20,
  },
  toast: {
    /** Must be above any modal layer (baseZIndex + nestedZIndexOffset stack). */
    zIndex: 20000,
    bottomPx: 24,
    visibleDurationMs: 2000,
  },
} as const

export const getModalAnimationDurationMs = (preferReducedMotion: boolean): number => {
  return preferReducedMotion ? 0 : modalConfig.animation.enterExitDurationMs
}

export const getModalActivateDelayMs = (preferReducedMotion: boolean): number => {
  return preferReducedMotion ? 0 : modalConfig.animation.activateDelayMs
}
